// extracted by mini-css-extract-plugin
module.exports = {"row":"CashbackModal_row__LpC4w","divider":"CashbackModal_divider__sYk4s","noClaimsContainer":"CashbackModal_noClaimsContainer__xYEHe"};